import paths from "@icarius-router/paths";
import {
    dateClassRule,
    dateFormatter,
    dateValueGetter,
    dateFilterParams,
    dateComparator,
} from "@icarius-table/date";
import { getLocalizedString } from "@icarius-localization/strings";

export default () => [
    {
        pages: [paths.myDigitalFolder],
        config: {
            field: "Instancia string",
            headerName: getLocalizedString("laborInstance"),
            filter: "agSetColumnFilter",
            chartDataType: "series",
            checkboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelectionFilteredOnly: true,
            enableRowGroup: true,
        }
    },
    {
        pages: [paths.myDigitalFolder],
        config:
        {
            field: 'Tipo string',
            headerName: getLocalizedString("fileType"),
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.myDigitalFolder],
        config:
        {
            field: 'Nombre archivo',
            headerName: getLocalizedString("digitalFolderNombredelarchivo"),
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.myDigitalFolder],
        config:
        {
            field: 'Texto',
            headerName: getLocalizedString("fileDescriptionText"),
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.myDigitalFolder],
        config: {
            field: 'Fecha de registro',
            headerName: getLocalizedString("initialLoadDate"),
            filter: "agTextColumnFilter",
            comparator: dateComparator,
            filterParams: dateFilterParams(),
            cellClassRules: dateClassRule,
            valueFormatter: dateFormatter,
            valueGetter: dateValueGetter,
        }
    },
    {
        pages: [paths.myDigitalFolder],
        config: {
            field: 'Hora de registro',
            headerName: getLocalizedString("initialLoadTime"),
            filter: "agTextColumnFilter",
            comparator: dateComparator,
            filterParams: dateFilterParams(),
            cellClassRules: dateClassRule,
            valueFormatter: dateFormatter,
            valueGetter: dateValueGetter,
        }
    },
    {
        pages: [paths.myDigitalFolder],
        config: {
            field: 'Nombre registro',
            headerName: getLocalizedString("digitalFolderResponsabledelacarga"),
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.myDigitalFolder],
        config: {
            headerName: getLocalizedString("lastUpdateDate"),
            field: 'Fecha de actualizacion',
            filter: "agTextColumnFilter",
            comparator: dateComparator,
            filterParams: dateFilterParams(),
            cellClassRules: dateClassRule,
            valueFormatter: dateFormatter,
            valueGetter: dateValueGetter,
        }
    },
    {
        pages: [paths.myDigitalFolder],
        config: {
            headerName: getLocalizedString("lastUpdateTime"),
            field: 'Hora actualizacion',
            filter: "agTextColumnFilter",
            comparator: dateComparator,
            filterParams: dateFilterParams(),
            cellClassRules: dateClassRule,
            valueFormatter: dateFormatter,
            valueGetter: dateValueGetter,
        }
    },
    {
        pages: [paths.myDigitalFolder],
        config: {
            field: 'Fecha de vencimiento string',
            headerName: getLocalizedString("annexFechaVencimiento"),
            filter: "agTextColumnFilter",
            comparator: dateComparator,
            filterParams: dateFilterParams(),
            cellClassRules: dateClassRule,
            valueFormatter: dateFormatter,
            valueGetter: dateValueGetter,
        }
    },
]